import script from "./ComplianceItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./ComplianceItem.vue?vue&type=script&lang=ts&setup=true"

import "./ComplianceItem.vue?vue&type=style&index=0&id=db3bb0e8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db3bb0e8"]])

export default __exports__